<template>
  <v-app>
    <portal-sysbar :show-customer="false"></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title :title="$t('message.aside.adminloco')"></portal-title>
      <portal-breadcumb></portal-breadcumb>
      <div class="content">
        <v-row>
          <v-col class="d-flex" cols="12" sm="4" md="3">
            <v-autocomplete :items="ecmList"  outlined dense hide-details solo item-value="id"
            item-text="name" label="ECM"  @change="filterByEcm"></v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4" md="3">
            <v-autocomplete v-model="selectedAsset" :items="assetList"
            :label="$t('message.infoloc.locomotive', { value: 'default' })"
            outlined dense hide-details solo @change="loadLoco"></v-autocomplete>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn class="mr-2" color="#CCD2D5" @click="setAlertDialog(true)">
              <v-icon>mdi-plus</v-icon>
              {{ $t("message.magic.sr", { value: "default" }) }}
            </v-btn>
            <v-btn color="#CCD2D5" @click="setUsageDialog(true)">
              <v-icon>mdi-plus</v-icon>
              {{ $t("message.magic.mileage", { value: "default" }) }}
            </v-btn>
          </v-col>
        </v-row>
        
        <v-row v-if="asset">
          <v-tabs v-model="tab" color="basil" grow class="mb-1">
            <v-tab key="data">
              Data
            </v-tab>
            <v-tab key="history">
              History
            </v-tab>
            <v-tab key="wheelset">
              Wheelset
            </v-tab>
            <v-tab key="contract">
              Contract
            </v-tab>
          </v-tabs>
          
          <v-tabs-items v-model="tab" class="tab-content">
            <v-tab-item key="data">
              <locomotive-data 
                :asset="asset"
                :workorder="workorder"
                :homologations="homologations"
                :pleft="pleft"
                :calcduedate="calcduedate"
                :remark="remark"
              />
            </v-tab-item>
            
            <v-tab-item key="history">        
              <locomotive-history
                :srs="srs"
                :km-datas="meterKMdatas"
                :hm-datas="meterHMdatas"
              />
            </v-tab-item>
        
            <v-tab-item key="wheelset">
              <wheelset
                :wheelsets="wheelsets"
                :wheelsets-nums="wheelsetsNums"
              />
            </v-tab-item>

            <v-tab-item key="contract">
              <contract
                :asset="asset"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-row>
        <div v-else class="mt-3">
          <b>Aucune locomotive selectionnée</b>
        </div>
      </div>
    </div>
    <v-dialog v-model="signalDialog" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
      <portal-signalement :assets="modalAssetList" :customer="getterCurrentClient" :user="getterContact"
      v-on:srClose="setAlertDialog(false)" has-hotline></portal-signalement>
    </v-dialog>
    <v-dialog v-model="kmDialog" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
      <portal-km v-on:kmClose="setUsageDialog(false)" :assets="modalAssetList" :customer="getterCurrentClient"
      :user="getterContact.mail"></portal-km>
    </v-dialog>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import PortalSignalement from "@/components/PortalSignalement";
import PortalKm from "@/components/PortalKm.vue";
import LocomotiveData from "@/components/locomotiveData/LocomotiveData.vue";
import LocomotiveHistory from "@/components/locomotiveData/LocomotiveHistory.vue";
import Wheelset from "@/components/locomotiveData/Wheelset.vue";
import Contract from "@/components/locomotiveData/Contract.vue";
import { mapGetters, mapActions } from "vuex";
import MaximoService from "@/services/MaximoService";

export default {
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    PortalSignalement,
    PortalKm,
    LocomotiveData,
    LocomotiveHistory,
    Wheelset,
    Contract,
  },
  data() {
    return {
      ecmList: [],
      assetList: [],
      tab: null,
      asset: null,
      workorder: null,
      remark: null,
      wheelsets: [],
      wheelsetsNums: [],
      homologations: [],
      calcduedate: '',
      pleft: '',
      selectedAsset: '',
      meterKMdatas: [],
      meterHMdatas: [],
      srs: [],
      signalDialog: false,
      kmDialog: false,
    }
  },
  title: "Info locomotive",
  methods: {
    ...mapActions("carpet", {
      getAllLocos: "loadAllAssets"
    }),
    initReferential() {
      MaximoService.loadAssetNums().then(({ data }) => {
        this.assetList = data.locomotives;
        this.ecmList = data.maintainers;
      });
    },
    async filterByEcm(code) {
      if (!code) {
        const { data } = await MaximoService.loadAssetNums();
        this.assetList = data.locomotives;
        return;
      }
      const { data } = await MaximoService.loadAssetByCompany(code);
      this.assetList = data;
    },
    loadLoco(loconum) {
      MaximoService.getAssetByAssetnum(loconum).then(({ data }) => {
        this.asset = data;
        this.workorder = data?.workorder;
      });
      
      MaximoService.getNextMaintenancePlan(loconum).then(({ data }) => {
        this.calcduedate = data.calcduedate;
        this.pleft = data.pleft;
      });
      
      MaximoService.getWheelsetMeasureDates(loconum).then(({ data }) => {
        this.wheelsets = data;
      });
      
      MaximoService.getMeterdataByAsset(loconum).then(({ data }) => {
        this.meterKMdatas = data.filter(m => m.metername == "MILEAGE");
        this.meterHMdatas = data.filter(m => m.metername == "H0URS");
      });
      
      MaximoService.getOpenSrByAsset('internal', loconum).then(({ data }) => {
        this.srs = data;
      });
      
      MaximoService.getWheelsets(loconum).then(({ data }) => {
        this.wheelsetsNums = data;
      });

      MaximoService.getAssetHomologation(loconum).then(({ data }) => {
        this.homologations = data;
      });
    },
    setAlertDialog(bool) {
      this.signalDialog = bool;
    },
    setUsageDialog(bool) {
      this.kmDialog = bool;
    },
  },
  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterContact: "getUserContact",
    }),
    ...mapGetters("carpet", {
      getterAssets: "getAssets"
    }),
    modalAssetList() {
      return this.selectedAsset ? [this.selectedAsset] : this.assetList;
    },
  },
  mounted() {
    this.initReferential();
  }
}
</script>

<style>
.v-expansion-panel-header {
  color: #fff;
}

.portal-deep-blue-bg {
  padding: 5px 0px 5px 10px;
  color: #fff;
  text-transform: uppercase;
}

.dp {
  color: #00475a;
  font-weight: bolder;
}
.dp-gray.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>th.shrink {
  white-space:nowrap;
}

.dp-gray.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  background-color: #c4c7c9;
  font-weight: bolder;
  color: #00475a;
  text-align: center;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  text-align: center;
}

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 14px;
}

.value {
  font-size: 16px;
}

.schema-text {
  font-size: 10px;
}

.tab-content {
  width: 100%;
}
</style>